import React, {FunctionComponent, useContext} from 'react';
import './InvoiceOptionTile.scss';
import {InvoiceOption} from "../../models/item.model";
import {VerticalDivider} from "../ui-components/VerticalDivider/VerticalDivider";
import {UI_PARAMS} from "@flicent/fieldpulse-react-component-library-frontend";
import {Button} from "../ui-components/Button/Button";
import {useIsMobileDevice} from "../../hooks/useIsMobileDevice";
import {InvoiceContext} from "../../context/InvoiceContext";

export interface InvoiceOptionTileProps {
    option: InvoiceOption;
    isSelectedOption: boolean;
    onSelectOption: (selectedOption: InvoiceOption) => void;
}

export const InvoiceOptionTile: FunctionComponent<InvoiceOptionTileProps> = ({
                                                                                 option,
                                                                                 onSelectOption,
                                                                                 isSelectedOption
                                                                             }) => {
    const isMobileDevice = useIsMobileDevice(true);
    const invoice = useContext(InvoiceContext);

    return (
        <article className="invoice-option-tile selected-option-information">
            {
                option.photo_src &&
                <section className="photo-container">
                    <img src={option.photo_src} alt={`Selected Option Picture`}/>
                </section>

            }

            {
                (option.description?.length > 0 && !isMobileDevice) && <VerticalDivider color={UI_PARAMS.DIVIDER_COLOR}
                                                                   width={3}
                                                                   borderRadius={5}
                                                                   margin={'0 15px 0 0'}/>
            }

            <section className="main-info-container">
                <h3>{option.title || ''}</h3>
                {
                    option?.description.length > 0 && <p className="selected-option-description">{option.description}</p>
                }
            </section>

            <section className="select-info-container">
                {invoice.is_subtotal_visible && <h4 className="option-price">
                    {option.total}
                </h4>}

                {
                    !isSelectedOption &&
                        <div>
                            <Button className='selected-option-action-button fp-button'
                                    onClick={() => onSelectOption(option)}>
                                <i className="fa-regular fa-check"></i>
                                Select Option
                            </Button>
                        </div>
                }
            </section>
        </article>
    );
};
